module.exports = __webpack_public_path__ + "img/dark-logo.5fed16f5.gif";